'use client';

import { c as _c } from "react/compiler-runtime";
import { AnimatePresence, motion } from 'motion/react';
import { useState } from 'react';
import { useInterval } from '@src/hooks/useInterval';
import { cn } from '@src/utils/tailwind';
import { textStyleMap } from '../Builder/Text/Text';
import { SlidingTextDefaultProps } from './SlidingText.defaults';
export interface SlidingTextProps {
  items: Array<{
    value: string;
  }>;
  speed: number;
  duration: number;
  itemColor: string;
  itemStyle: keyof typeof textStyleMap;
}
export const SlidingText = t0 => {
  const $ = _c(30);
  const props = t0 === undefined ? SlidingTextDefaultProps : t0;
  const {
    items,
    itemColor,
    itemStyle,
    speed,
    duration
  } = props;
  const [index, setIndex] = useState(0);
  let t1;
  if ($[0] !== items.length) {
    t1 = () => {
      setIndex(state => (state + 1) % items.length);
    };
    $[0] = items.length;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  useInterval(t1, Number(duration) * 1000);
  const t2 = textStyleMap[itemStyle];
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      color: "transparent"
    };
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== items[0].value) {
    t4 = {
      __html: items[0].value
    };
    $[3] = items[0].value;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== t2 || $[6] !== t4) {
    t5 = <div className={t2} style={t3} dangerouslySetInnerHTML={t4} />;
    $[5] = t2;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  const t6 = items[index];
  const t7 = t6.value;
  let t10;
  let t8;
  let t9;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = {
      y: "-100%",
      opacity: 0
    };
    t9 = {
      y: 0,
      opacity: 1
    };
    t10 = {
      y: "100%",
      opacity: 0
    };
    $[8] = t10;
    $[9] = t8;
    $[10] = t9;
  } else {
    t10 = $[8];
    t8 = $[9];
    t9 = $[10];
  }
  let t11;
  if ($[11] !== speed) {
    t11 = {
      y: {
        duration: speed
      },
      opacity: {
        duration: speed
      }
    };
    $[11] = speed;
    $[12] = t11;
  } else {
    t11 = $[12];
  }
  const t12 = textStyleMap[itemStyle];
  let t13;
  if ($[13] !== t12) {
    t13 = cn("text-center", t12);
    $[13] = t12;
    $[14] = t13;
  } else {
    t13 = $[14];
  }
  let t14;
  if ($[15] !== itemColor) {
    t14 = {
      color: itemColor
    };
    $[15] = itemColor;
    $[16] = t14;
  } else {
    t14 = $[16];
  }
  const t15 = items[index];
  let t16;
  if ($[17] !== t15.value) {
    t16 = {
      __html: t15.value
    };
    $[17] = t15.value;
    $[18] = t16;
  } else {
    t16 = $[18];
  }
  let t17;
  if ($[19] !== t13 || $[20] !== t14 || $[21] !== t16) {
    t17 = <div className={t13} style={t14} dangerouslySetInnerHTML={t16} />;
    $[19] = t13;
    $[20] = t14;
    $[21] = t16;
    $[22] = t17;
  } else {
    t17 = $[22];
  }
  let t18;
  if ($[23] !== t11 || $[24] !== t17 || $[25] !== t6.value) {
    t18 = <AnimatePresence><motion.div key={t7} className="absolute top-0 left-0 flex w-full justify-center" initial={t8} animate={t9} exit={t10} transition={t11}>{t17}</motion.div></AnimatePresence>;
    $[23] = t11;
    $[24] = t17;
    $[25] = t6.value;
    $[26] = t18;
  } else {
    t18 = $[26];
  }
  let t19;
  if ($[27] !== t18 || $[28] !== t5) {
    t19 = <div className="relative text-center text-black">{t5}{t18}</div>;
    $[27] = t18;
    $[28] = t5;
    $[29] = t19;
  } else {
    t19 = $[29];
  }
  return t19;
};